class Header {
  constructor() {
    this.stickyHeader();
    this.navigation();
    this.search();
  }

  navigation = () => {
    const navigation = document.querySelector(".js-navigation");
    const hamburger = document.querySelector(".js-hamburger");
    const navExit = document.querySelector(".js-nav-exit");
    const menuButtons = document.querySelectorAll(".js-sub-menu-btn");
    menuButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const subMenu = btn.parentNode.parentNode.querySelector(".sub-menu");
        subMenu.classList.toggle("active");
        btn.classList.toggle("active");
      });
    });
    hamburger.addEventListener("click", () => {
      navigation.classList.add("active");
    });
    navExit.addEventListener("click", () => {
      navigation.classList.remove("active");
    });
  };

  search = () => {
    const btn = document.querySelector(".js-search-btn");
    const modal = document.querySelector(".js-search-modal");
    btn.addEventListener("click", () => {
      modal.classList.toggle("active");
    });
    modal.addEventListener("click", (e) => {
      if (
        e.target.classList.contains("js-search-modal") ||
        e.target.classList.contains("js-search-modal-content")
      ) {
        modal.classList.remove("active");
      }
    });
  };

  stickyHeader = () => {
    const header = document.querySelector(".js-header");
    let prevPosY = window.scrollY;
    if (window.scrollY > 10) {
      header.classList.add("not-top");
    }

    addEventListener("scroll", () => {
      const posY = window.scrollY;
      if (posY < 10) {
        header.classList.remove("not-top");
      } else {
        header.classList.add("not-top");
      }
      if (posY <= prevPosY || posY <= 0) {
        header.classList.remove("hide");
      } else {
        header.classList.add("hide");
      }
      prevPosY = posY;
    });
  };
}
new Header();
